module.exports = __webpack_public_path__ + "static/media/Group 38204.d1a64388.svg";